export default __webpack_public_path__ + "static/media/p2023-42.ca616690.jpeg";